<template>
    <section class="font-poppins">
        <TheHeader/>
        <div class="image-container relative pt-20 ">
            <img src="../Images/carrgo-team.jpg" class="images relative" alt="">
            <div  class=" centered  text-white md:text-sm md:mt-4 sm:w-full">
                <p  class="text-4xl text-center leading-10  md:text-sm sm:hidden md:mt-20">
                    Ride to earn, Ride to own, and Ride Alive on the CarryGo Hired Purchase Program
                </p>
                <div class="flex justify-center mt-6 sm:mt-1">
                    <router-link to="/step-one-registration" class="p-2 sm:p-0 border border-gray-100 rounded-lg font-semibold md:text-xs">Sign Up For Hired Purchase</router-link>
                </div>
                
            </div>
        </div>

        <div class="flex justify-around mt-10 md:flex-col pb-20 md:pb-6">
            <div class="w-1/3 mt-10 md:w-full md:mt-4 md:p-2">
                <p class="font-bold text-blue-600 text-xl mb-4 md:text-lg"> CG-HIRED PURCHASE </p>
                <p class="leading-7">
                   On a soft and easy remittance of just NGN20,100 weekly or NGN3350 Daily, combined with high volume delivery engagements in daily orders and strategic tie ups via the CarryGo App, you get an amazing opportunity to earn money, own a motorbike and get trained to ride alive with CarryGo. 

                    With us you pay less slowly and you earn more faster. Our offer is already up for grabs. Why don't you make the move and CarryGo!!!!

                </p>
                <div class="mt-8">
                    <router-link to="/step-one-registration" class="p-2 border border-blue-700 text-blue-700 rounded-lg text-sm">SIGN UP FOR HIRED PURCHASE</router-link>
                </div>
                
            </div>

            <div class="w-1/2 md:w-full md:mt-6">
                <img class="rounded-lg" src="../Images/carrygo-bikes.jpg" alt="">
            </div>
        </div>
        <div>
         <TheFooter/>
        </div>
    </section>
</template>

<script>
import TheHeader from '../../layout/TheHeader.vue';
import TheFooter from '../../layout/TheFooter.vue';
export default {
    components : {
        TheHeader,
        TheFooter
    }
}
</script>

<style scoped>

.images {
    width: 100%;
    opacity: 0.4;
}

.image-container {
background-color: black;
}

.centered {
  position: absolute;
  top: 50%;
  left: 50%;
  transform: translate(-50%, -50%);
}
</style>
